import './Graphs/graphStyles.scss'
import { CSVLink } from "react-csv";



export function ExportCSVButton({ allData, name, style, title="Export to CSV" }) {

    const csvData = [['CausalFunnel Dashboard Generated Report'], ['  '], ...allData]

    return (
        <button className='csv__button' style={ style }>
            <CSVLink data={csvData} filename={name} >
                {title}
            </CSVLink>
        </button>
    )
}